import React, { useState, useEffect } from 'react';
import FAQ from './FAQ';
import FAQ2 from './FAQ2';
import './FaqPage.scss';
import './Accordion.css';
import MetaTags from 'react-meta-tags';

export default (function FaqPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [faqs, setfaqs] = useState([
    {
      question: 'Was ist Kaschmir?',
      answer:
        'Kaschmir ist das weiche Unterfell von Ziegen, die in den weiten Wiesen der Mongolei und der Wüste Gobi leben. Unter dem groben Deckhaar einer Ziege wächst das wertvolle Unterfell, eine viel feinere Faser, die sie vor der bitteren Kälte schützt.',
      open: false,
    },
    {
      question: 'Werden die Ziegen bei der Kaschmir-Ernte in irgendeiner Weise geschädigt?',
      answer:
        'Unser Kaschmir stammt von mongolischen Ziegen, die vom Nomaden des Landes gezüchtet werden. Sie bilden immer noch die Mehrheit der Bevölkerung und ihre Lebensweise hat sich im Laufe der Jahrhunderte kaum verändert. Während des Fellwechsels im Frühjahr, wenn Ziegen ihr Unterfell allmählich verliert, kämmen nomadische Hirten mit Generationen von Fachkenntnissen die feinen Edelwolle sorgfältig mit der Hand aus, ohne den Ziegen Stress oder Schaden zuzufügen. Es ist die nachhaltigste und humanste Art, Rohkaschmir zu ernten.',
      open: false,
    },
    {
      question: 'Wie kann man wissen, dass der Kaschmir hochwertig ist?',
      answer:
        'Der einfachste Weg, die Qualität des Kaschmirs zu überprüfen, ist den Kaschmir zu berühren. Kaschmir ist die einzige Faser, die einen sehr schmalen Durchmesser hat, wodurch sie sich extrem weich anfühlt. Selbst bei einer leichten Berührung sollten Sie das sanfte und angenehme Gefühl spüren, wenn es sich um ein hochwertiges Kaschmir handelt. Laut der vom US-Kongress 1939 erlassenen Kennzeichnung von Wollprodukten darf Kaschmir einen Durchmesser von höchstens 19 Mikron haben. Einige Teile der Mongolei produzieren sogar Kaschmir mit einem Durchmesser zwischen 13 und 14 Mikron. Daher ist mongolisches Kaschmir dafür bekannt, sich von höchster Qualität abzuheben.',
      open: false,
    },
    {
      question: 'Kann man 100% Kaschmir waschen?',
      answer:
        'Je nach Produkttyp werden unterschiedliche Pflegehinweise empfohlen. Lesen Sie sorgfältig das Pflegeetikett auf dem Produkt durch. Wir empfehlen eine Trockenreinigung für die lange Haltbarkeit und Frische der Kaschmirprodukte. Weitere Informationen finden Sie auf unserer Seite zur  Produktpflege. ',
      answerLink: 'https://gobicashmere.com/de/pages/cashmere-care',
      open: false,
    },
    {
      question: 'Was ist Pilling?',
      answer:
        'Beim Pilling entstehen kleine Knötchen und zwar genau dort, wo die größten Reibungspunkte bestehen, also etwa an den Unterarmen, im Schulter- oder im Bundbereich. Es ist eine natürliche Eigenschaft und kein Merkmal für mangelnde Qualität. Bei einem Kaschmirprodukt von GOBI entsteht Pilling je nach Kleidungsstück nur ein- oder zweimal. Pilling lässt sich schnell mit einem Kaschmirkamm entfernen oder einfach von Hand abziehen.',
      open: false,
    },
    {
      question: 'Warum fühlt sich Kaschmir mit hellen Farben weicher an, als mit dunkleren?',
      answer:
        'Weiß, Beige, warmes Grau und Braun sind die natürlich vorkommenden Farben bei mongolischen Ziegen. Jede Farbe hat ihre eigenen Eigenschaften. Bei GOBI wird die Organic-Qualität des mongolischen Kaschmirs in den Produktionsphasen nicht verändert. Produkte aus dem „Gobi Mongolian Organic Cashmere“ werden nicht gebleicht und gefärbt und ohne Kompromisse hergestellt, was die Weichheit des hellen Kaschmirs erklärt.',
      open: false,
    },
    {
      question: 'Ist Kaschmir schädlich für meine Haut?',
      answer:
        'Da unser Garn nach OEKO TEX 100-Standards für jede Haut unbedenklich ist, empfehlen wir unsere Produkte mit Stolz für Menschen jeden Alters, einschließlich  für Kinder unter einem Jahr.',
      open: false,
    },
    {
      question: 'Warum ist mongolischer Kaschmir weich?',
      answer:
        'Mongolischer Kaschmir zeichnet sich durch eine unglaubliche Weichheit aus, die das Ergebnis von feinen Fasern ist, die sich fast seidig anfühlen. Es juckt nicht wie Wolle, bietet aber dennoch isolierende Wärme, ohne dass man sich viele Kleidungsschichten tragen muss. Deshalb ist Kaschmir so ein begehrter Stoff.',
      open: false,
    },
    {
      question: 'Kann man Kaschmir auch im Sommer tragen?',
      answer:
        'Obwohl Kaschmir wärmer als Wolle ist, ist es hoch atmungsaktiv und leicht. Kaschmir ist auch hygroskopisch, was bedeutet, dass es im Gegensatz zu synthetischen Fasern ein natürlich atmungsaktives Material ist. Es hat einen hohen Feuchtigkeitsgehalt und wenn sich die Luftfeuchtigkeit ändert, ändert sich auch die Isolierung, sodass es auch im Sommer angenehm zu tragen ist.',
      open: false,
    },
    {
      question: 'Woraus bestehen Ihre Produkte?',
      answer:
        'Die auf unserer Verkaufsplattform beworbenen Produkte bestehen hauptsächlich aus 100% Kaschmir. In der Produktbeschreibung finden Sie die Zusammensetzung unserer Produkte. Darüber hinaus produziert GOBI Produkte aus folgenden Zusammensetzungen; 70% Kaschmir und 30% Seide 60% Kaschmir und 25% Baumwolle und 15% Seide',
      open: false,
    },
  ]);
  const [faqs2, setfaqs2] = useState([
    {
      question: 'Wie kann ich meine Bestellung zurückgeben?',
      answer: 'Bitte klicken Sie auf folgenden Link: ',
      answerLink: 'https://gobicashmere.shipping-portal.com/rp/',
      answer3:
        ' und geben Sie Ihre Postleitzahl und Bestellnummer ein, um den Vorgang zu starten. Wenn der Link nicht ordnungsgemäß funktioniert, wenden Sie sich bitte an unseren Kundenservice, um ein Rücksendeetikett zu erhalten. Email: support-1@gobicashmere.com Hinweis: Der Link funktioniert  nicht in der Schweiz aufgrund schweizerischer Zollbestimmungen.',
      open: false,
    },
    {
      question: 'Wie verfolge ich meine Bestellung?',
      answer: 'Bitte geben Sie Ihre DHL-Verfolgungsnummer  über den folgenden Link ein. ',
      answerLink: 'https://www.dhl.de/de/privatkunden.html ',
      answer3:
        ' Wenn es kein Ergebnis gibt, geben Sie Ihre Postleitzahl in den Eingabebereich ein. Eine DHL-Verfolgungsnummer  wird Ihnen nach dem Versand Ihrer Bestellung automatisch zugesandt.',
      open: false,
    },
    {
      question: 'Liefern Sie in Länder ausserhalb der EU?',
      answer:
        'Wir liefern in Länder außerhalb der EU. Beachten Sie bitte jedoch, dass die Lieferung normalerweise bis zu 4 Wochen dauern kann. Wenn Sie in den USA oder in Kanada wohnen, geben Sie bitte  Ihre Bestellung auf  der folgenden Website auf: us.gobicashmere.com  ',
      open: false,
    },
    {
      question: 'Kann ich meine Bestellung zurückgeben oder umtauschen?',
      answer: 'Für detailliertere Informationen klicken Sie bitte auf den folgenden Link; ',
      answerLink: 'https://gobicashmere.com/de/pages/versand-und-ruckgabebedingungen',
      open: false,
    },
    {
      question: 'Was ist, wenn das gewünschte Produkt nicht verfügbar ist?',
      answer:
        'Bitte besuchen Sie unsere Website von Zeit zu Zeit, ob Ihr gewünschtes Produkt wieder   verfügbar ist. Normalerweise dauert der Lagerauffüllungsprozess 4-6 Wochen.',
      open: false,
    },
    {
      question: 'Wo ist Ihr Lagerstandort?',
      answer: 'GOBI Cashmere Europe GmbH Genshagener Str. 27, Halle 4, 14974 Ludwigsfelde Deutschland',
      open: false,
    },
    {
      question: 'Wie lange dauert die Lieferung?',
      answer:
        'Unter normalen Umständen werden die Produkte innerhalb von 2 Werktagen verpackt und an unseren Logistikpartner übergeben. Die tatsächlichen Lieferzeiten variieren zwischen 2-4 Werktagen innerhalb Deutschlands und 3-14 Werktagen in andere EU-Länder. Außerhalb der EU-Länder kann die Lieferung je nach Bestimmungsort bis zu 4 Wochen dauern. Im Extremfall kann es bis zu 14 Werktage innerhalb Deutschlands und 21 Werktage in anderen EU-Ländern dauern. Wenn eine Lieferung länger dauern sollte als oben beschrieben, kontaktieren Sie uns bitte unter support-1@gobicashmere.com oder +49 (0) 33 7934 189 32. In diesem Fall wird durch uns ein Nachforschungsauftrag bei DHL gestellt.',
      open: false,
    },
    {
      question: 'Ich habe eine Bestellung aufgegeben, aber warum habe ich keine Bestätigung per E-Mail erhalten?',
      answer:
        'Überprüfen Sie in diesem Fall Ihren Spam-Ordner. Andernfalls kontaktieren Sie unseren Kundenservice über Tel.: +49 (0)33 79 34 18 932 oder E-Mail: support-1@gobicashmere.com',
      open: false,
    },
    {
      question:
        'Ich habe beim Aufgeben einer Bestellung falsche Informationen eingegeben. Wie ändere ich meine Versandadresse oder Rechnungsadresse?',
      answer:
        'Kontaktieren Sie bitte unseren Kundendienst umgehend innerhalb von 12 Stunden über Tel: +49 (0)33 79 34 18 932 oder E-Mail: support-1@gobicashmere.com',
      open: false,
    },
    {
      question: 'Woher weiß ich, welche Größe für mich geeignet ist?',
      answer:
        'Wenn Sie sich nicht sicher sind, welche Größe für Sie geeignet ist, senden Sie uns bitte per E-Mail den Link der Produkte sowie die Größe und das Gewicht der Person, für die Sie einkaufen möchten. Unser professionelles Personal schlägt Ihnen die richtige Größe vor.',
      open: false,
    },
    {
      question: 'Wie storniere ich meine Bestellung?',
      answer:
        'Wir empfehlen, uns innerhalb von 24 Stunden zu benachrichtigen, bevor wir Ihre Bestellung versenden; Tel: +49 (0)33 79 34 18 932 oder E-Mail: support-1@gobicashmere.com. Oder wenn Sie Ihre Meinung ändern, nachdem wir Ihre Bestellung bereits versandt haben, können Sie Ihre Bestellung bei der Lieferung ablehnen und wir werden Ihre Rückerstattung sofort bearbeiten.',
      open: false,
    },
    {
      question: 'Ich habe ein falsches Produkt / eine falsche Bestellung erhalten. Was kann ich machen?',
      answer:
        'Kontaktieren  Sie bitte umgehend unseren Kundenservice, um Abhilfe zu schaffen. Tel: +49 (0)33 79 34 18 932 oder E-Mail: support-1@gobicashmere.com',
      open: false,
    },
    {
      question: 'Was passiert, wenn mein Paket verloren geht?',
      answer:
        'In diesem Fall werden wir als Absender des Pakets DHL kontaktieren und einen formellen Untersuchungsantrag an DHL senden. Unser Logistikpartner (DHL) wird eine offizielle Untersuchung bezüglich der verlorenen Sendung durchführen. Die Untersuchung kann bis zu 10 Werktage dauern.',
      open: false,
    },
    {
      question: 'Ich habe ein fehlerhaftes Produkt erhalten. Wie kann ich es gegen einen neuen austauschen?',
      answer:
        'Wir empfehlen Ihnen, jeden Artikel in Ihrer Bestellung bei Lieferung zu überprüfen, und wenn defekte Produkte vorhanden sind, melden Sie uns unverzüglich über: Tel: +49 (0)33 79 34 18 932 oder E-Mail: support-1@gobicashmere.com.',
      open: false,
    },
    {
      question: 'Haben Sie Umtauschbedingungen?',
      answer:
        'Leider bieten wir keinen Umtausch an, Sie können den Artikel einfach zurückgeben und eine neue Bestellung bei uns aufgeben. ',
      open: false,
    },
  ]);

  const toggleFAQ = (index) => {
    setfaqs(
      faqs.map((faq, i) => {
        if (i === index) {
          faq.open = !faq.open;
        }
        return faq;
      }),
    );
  };

  const toggleFAQ2 = (index) => {
    setfaqs2(
      faqs2.map((faq2, i) => {
        if (i === index) {
          faq2.open = !faq2.open;
        }
        return faq2;
      }),
    );
  };

  return (
    <div>
      <MetaTags key={0}>
        <title>THIS IS HOW WE PRODUCE YOUR CASHMERE!</title>
        <meta property="og:title" content="Premium Cashmere Brand - Gobi Cashmere" />
        <meta property="og:type" content="website" />
      </MetaTags>
      <div className="faq-page">
        <div className="page-width page-content">
          <div className="faq_grid">
            <div className="faq-col-12">
              <div className="center">
                <h2>FAQ</h2>
                <div className="text">
                  <p>
                    Haben Sie Fragen zu Ihrer Bestellung oder zu unseren Produkten? Nachfolgend finden Sie unsere am
                    häufigsten gestellten Fragen. Hoffentlich finden Sie die Antworten, die Sie suchen. Wenn nicht,
                    können Sie uns gerne kontaktieren.
                  </p>
                </div>
              </div>
            </div>

            <div className="faq-col-6">
              <div className="big_tt">
                <h2>PRODUKTBEZOGEN</h2>
              </div>

              <div className="faqs">
                {faqs.map((faq, i) => (
                  <FAQ key={i} faq={faq} index={i} toggleFAQ={toggleFAQ} />
                ))}
              </div>
            </div>
            <div className="faq-col-6">
              <div className="big_tt_2">
                <h2>KAUFBEZOGEN</h2>
              </div>
              <div className="faqs">
                {faqs2.map((faq2, i) => (
                  <FAQ2 key={i} faq2={faq2} index={i} toggleFAQ2={toggleFAQ2} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
